
  

  /**
   * Bestsellers Carousel (Mobile Only)
   */
  let currentProduct = 0;

  function initBestsellersCarousel() {
    // Only initialize on mobile
    if (window.innerWidth > 768) return;

    const productsGrid = document.querySelector('.hfw-product-grid');
    if (!productsGrid) return;

    // Track current scroll position for button navigation
    productsGrid.addEventListener('scroll', function() {
      const cardWidth = productsGrid.querySelector('.hfw-product-card').offsetWidth;
      const scrollPosition = productsGrid.scrollLeft;
      currentProduct = Math.round(scrollPosition / cardWidth);
    }, { passive: true });
  }

  window.hfwPreviousProduct = function() {
    if (window.innerWidth > 768) return;

    const productsGrid = document.querySelector('.hfw-product-grid');
    if (!productsGrid) return;

    const productCards = productsGrid.querySelectorAll('.hfw-product-card');
    const totalProducts = productCards.length;

    if (totalProducts === 0) return;

    currentProduct = currentProduct > 0 ? currentProduct - 1 : totalProducts - 1;

    // Scroll to the product
    const cardWidth = productCards[0].offsetWidth + 15; // width + gap
    productsGrid.scrollTo({
      left: currentProduct * cardWidth,
      behavior: 'smooth'
    });
  };

  window.hfwNextProduct = function() {
    if (window.innerWidth > 768) return;

    const productsGrid = document.querySelector('.hfw-product-grid');
    if (!productsGrid) return;

    const productCards = productsGrid.querySelectorAll('.hfw-product-card');
    const totalProducts = productCards.length;

    if (totalProducts === 0) return;

    currentProduct = (currentProduct + 1) % totalProducts;

    // Scroll to the product
    const cardWidth = productCards[0].offsetWidth + 15; // width + gap
    productsGrid.scrollTo({
      left: currentProduct * cardWidth,
      behavior: 'smooth'
    });
  };

  /**
   * Flip Card Functionality
   */
  window.hfwFlipCard = function(card) {
    if (!card) return;
    card.classList.toggle('flipped');
  };

  /**
   * Video Testimonials
   */
  function initVideoTestimonials() {
    // Click handlers are already in HTML onclick attributes
    // Just ensure videos can be played/paused properly
  }

  window.hfwPlayVideo = function(tile) {
    if (!tile) return;

    const video = tile.querySelector('.hfw-video-preview');
    if (!video) return;

    if (video.paused) {
      // Pause all other videos
      document.querySelectorAll('.hfw-video-preview').forEach(v => {
        if (v !== video) {
          v.pause();
          v.closest('.hfw-video-tile').classList.remove('playing');
        }
      });

      video.play();
      tile.classList.add('playing');
    } else {
      video.pause();
      tile.classList.remove('playing');
    }
  };

  /**
   * FAQ Accordion
   */
  function initFAQAccordion() {
    // Don't add event listeners since onclick is already in HTML
    // Just ensure the function is available globally
  }

  window.hfwToggleFAQ = function(button) {
    if (!button) return;

    const answer = button.nextElementSibling;
    const isActive = button.classList.contains('active');

    // Close all FAQs
    document.querySelectorAll('.hfw-faq-question').forEach(q => {
      q.classList.remove('active');
      const a = q.nextElementSibling;
      if (a && a.classList.contains('hfw-faq-answer')) {
        a.classList.remove('active');
      }
    });

    // Open clicked FAQ if it wasn't already open
    if (!isActive) {
      button.classList.add('active');
      if (answer && answer.classList.contains('hfw-faq-answer')) {
        answer.classList.add('active');
      }
    }
  };

  /**
   * Stats Counter Animation
   */
  function initStatsCounter() {
    const counters = document.querySelectorAll('.hfw-stat-number');

    if (!counters.length) return;

    try {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting && entry.target) {
            animateCounter(entry.target);
            observer.unobserve(entry.target);
          }
        });
      });

      counters.forEach(counter => {
        if (counter) {
          observer.observe(counter);
        }
      });
    } catch (e) {
      // IntersectionObserver not supported or error
      counters.forEach(counter => {
        if (counter) {
          animateCounter(counter);
        }
      });
    }
  }

  function animateCounter(counter) {
    const target = counter.getAttribute('data-count');
    if (!target) return;

    // Simply set the final value without animation to avoid MutationObserver issues
    counter.textContent = target;
  }